import React, { createRef } from 'react';
import { focusFirstFocusableNode } from 'ui/utilities/focus';

class ModalContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
  }

  modalContainerRef = createRef();

  componentDidMount() {
    window.addEventListener('keyup', this.handleEscapeKey);
    document.body.style.overflow = 'hidden';
    if (this.modalContainerRef.current && !this.props.manualAutoFocus) {
      focusFirstFocusableNode(this.modalContainerRef.current);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.handleEscapeKey);
    document.body.style.overflow = 'visible';
  }

  handleEscapeKey(e) {
    const keyCode = e.keyCode || e.which;
    if (this.props.onEscape && keyCode === 27) {
      this.props.onEscape();
    }
  }

  render() {
    const { onEscape, manualAutoFocus, ...props } = this.props;
    return <div {...props} ref={this.modalContainerRef} />;
  }
}

export default ModalContainer;
